import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { Package, PackageListItem, PagedResult, PackageSearchParams, PackageProduct } from '../models/package.model';

@Injectable({
  providedIn: 'root'
})
export class PackageService {
  private readonly API_URL = `${environment.apiUrl}/packages`;

  constructor(private http: HttpClient) {}

  search(params: PackageSearchParams = {}): Observable<PagedResult<PackageListItem>> {
    let httpParams = new HttpParams();
    
    if (params.query) httpParams = httpParams.set('query', params.query);
    if (params.manufacturer) httpParams = httpParams.set('manufacturer', params.manufacturer);
    if (params.tags) httpParams = httpParams.set('tags', params.tags);
    if (params.minPrice !== undefined) httpParams = httpParams.set('minPrice', params.minPrice.toString());
    if (params.maxPrice !== undefined) httpParams = httpParams.set('maxPrice', params.maxPrice.toString());
    if (params.isFree !== undefined) httpParams = httpParams.set('isFree', params.isFree.toString());
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.pageSize) httpParams = httpParams.set('pageSize', params.pageSize.toString());

    return this.http.get<PagedResult<PackageListItem>>(this.API_URL, { params: httpParams });
  }

  getById(id: string): Observable<Package> {
    return this.http.get<Package>(`${this.API_URL}/${id}`);
  }

  getProducts(packageId?: string): Observable<PackageProduct[]> {
    let httpParams = new HttpParams();
    if (packageId) httpParams = httpParams.set('packageId', packageId);
    return this.http.get<{ items: PackageProduct[] }>(`${environment.apiUrl}/package-products`, { params: httpParams })
      .pipe(map(res => res.items || []));
  }

  purchase(packageId: string): Observable<any> {
    return this.http.post(`${this.API_URL}/${packageId}/purchase`, {});
  }
}
